import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

export const BubbleTypes = {
    correct: 'CORRECT',
    missing: 'MISSING',
    waiting: 'WAITING_FOR_CORRECTION',
    wrong: 'WRONG',
    incomplete: 'INCOMPLETE',
};

export const styles = {
    [BubbleTypes.correct]: {
        mainColor: 'var(--color-success-default)',
        hoverColor: 'var(--green200)',
        selectedColor: 'var(--color-white)',
    },
    [BubbleTypes.missing]: {
        mainColor: 'var(--gray200)',
        hoverColor: 'var(--gray50)',
        selectedColor: 'var(--text-gray-800)',
    },
    [BubbleTypes.wrong]: {
        mainColor: 'var(--color-error-default)',
        hoverColor: 'var(--red200)',
        selectedColor: 'var(--color-white)',
    },
    [BubbleTypes.incomplete]: {
        mainColor: 'var(--color-error-default)',
        hoverColor: 'var(--red200)',
        selectedColor: 'var(--color-white)',
    },
    [BubbleTypes.waiting]: {
        mainColor: 'var(--color-warning-default)',
        hoverColor: ' var(--yellow200)',
        selectedColor: 'var(--text-gray-800)',
    },
};

export const Container = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    max-width: 85px;

    @media (max-width: 767px) {
        max-width: 75px;
    }
    cursor: pointer;
    -webkit-tap-highlight-color: transparent;
`;

export const Circle = styled.div`
    align-items: center;
    background-color: ${(props) => props.isSelected && styles[props.type].mainColor};
    border-color: ${(props) => styles[props.type].mainColor};
    border-radius: 50%;
    border-style: solid;
    border-width: 4px;
    box-sizing: border-box;
    color: ${(props) => props.isSelected && styles[props.type].selectedColor};
    display: flex;
    font-size: 32px;
    font-weight: ${(props) => props.isSelected && '600'};
    height: 85px;
    justify-content: center;
    letter-spacing: 0;
    line-height: 40px;
    width: 85px;

    &:hover {
        border-color: ${(props) => styles[props.type].hoverColor};
        background-color: ${(props) => styles[props.type].hoverColor};
    }

    @media (max-width: 767px) {
        width: 75px;
        height: 75px;
    }
`;

export const Description = styled.span`
    font-size: 12px;
    font-weight: 600;
    line-height: 16px;
    letter-spacing: 0.32px;
    text-align: center;
    margin-top: 8px;
`;

const Bubble = ({ isSelected, type, number, description, onClick }) => {
    return (
        <Container onClick={() => onClick(type)}>
            <Circle type={type} isSelected={isSelected}>
                {number}
            </Circle>
            <Description>{description}</Description>
        </Container>
    );
};

Bubble.propTypes = {
    isSelected: PropTypes.bool,
    description: PropTypes.string,
    number: PropTypes.number,
    onClick: PropTypes.func,
    type: PropTypes.string,
};

export default Bubble;
